import FanduelLogo from '@/features/Logos/FanDuel/FanDuelLogo';
import MohegansunLogo from '@/features/Logos/Mohegansun/MohegansunLogo';
import PokerLogo from '@/features/Logos/Poker/PokerLogo.tsx';
import { useStore } from '@/store/useStore';
import { BRANDS, PRODUCTS } from '@/utilities/constants/game';

export const DefaultLogo = () => {
  const brand = useStore((s) => s.runtime.brand);
  const product = useStore((s) => s.runtime.product)?.toLowerCase();

  if (product === PRODUCTS.POKER) {
    return <PokerLogo />;
  }

  if (brand === BRANDS.FANDUEL) {
    return <FanduelLogo />;
  }

  if (brand === BRANDS.MOHEGANSUN) {
    return <MohegansunLogo />;
  }

  return null;
};
